import Game from "./scenes/Game";
import Intro from "./scenes/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,
    // startScene: Game.KEY,
    
    GAME_PAUSED: false,
    MUTE: false,
    GAME_DONE: false,
    DESKTOP:null,
    GAME_LEVEL: 1,
    CORRECT_SOUNDS:["Correct_Key_1", "Correct_Key_2", "Correct_Key_3", "Correct_Key_4", "Correct_Key_5", "Correct_Key_6", "Correct_Key_7", "Correct_Key_8", "Correct_Key_9", "Correct_Key_10", "Correct_Key_11", "Correct_Key_12"],
    ATTACK_SOUNDS:["Incorrect_Answer_1_Ghost_Typing", "Incorrect_Answer_2_Ghost_Typing", "Incorrect_Answer_3_Ghost_Typing"],
    GHOST_ARR: [],
    GHOSTPOS_ARR: [],
    GHOST_SEL: null,
    LIVES: 6,
    SCORE: 0,
    SPEED: 10000,
    SPEED_ADJ:100,
    WORD: "",
    /** @type {string[]} */
    WORDS_SELECTED: [],
    WORDS_MADE: 0,
    /** @type {string[]} */
    WORD_BANK:[]
}
